import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import * as React from 'react';
function Separator({ ref, className, orientation = 'horizontal', decorative = true, ...props }) {
    return (_jsx(SeparatorPrimitive.Root, { ref: ref, decorative: decorative, orientation: orientation, className: cn('shrink-0 bg-border', orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]', className), ...props }));
}
export { Separator };
